import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowUpRight, Check } from 'lucide-react';
import { useShop } from '../../components/shop/useShop';
import { idealForPT } from '../../components/shop/shopCopy';
import { ShopAvailability, ShopCover, ShopLanguage, ShopMeta } from '../../components/shop/ShopElements';
import '../../components/shop/shop.css';
import { ShopPurchase } from '../../components/shop/ShopPurchase';

export default function FicheDetail() {
  const { id } = useParams();
  const shop = useShop();
  const { t, lang, link, products: shopProducts } = shop;
  const product = shopProducts.find(p => p.id === id);
  useEffect(() => { window.scrollTo(0, 0); }, [id]);
  if (!product) return <div className="shop-container" lang={lang} data-testid="shop-not-found">
    <h1 className="text-4xl">{t.notFound}</h1><Link to={link()} data-testid="shop-not-found-back">{t.back}</Link>
  </div>;
  const copy = product[lang];
  const included = shopProducts.filter(p => p.kind === 'sheet' && product.included_numbers?.includes(Number(p.number)));
  const ideal = lang === 'pt' ? idealForPT[Number(product.number) - 1] : copy.ideal_for;
  return <div className="shop-container" lang={lang} data-testid="shop-detail-page">
    <div className="shop-detail-nav"><Link to={link()} className="shop-back" data-testid="shop-back"><ArrowLeft size={16}/>{t.back}</Link><ShopLanguage shop={shop}/></div>
    <div className="shop-detail-grid">
      <div className="shop-detail-cover"><ShopCover product={product} t={t} lang={lang}/><p className="shop-ai-note" data-testid="shop-ai-disclosure">{t.ai}</p></div>
      <section className="shop-detail-copy">
        <p className="shop-eyebrow" data-testid="shop-detail-number">{product.kind === 'sheet' ? `Setup ${product.number}` : t.collection}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl" data-testid="shop-detail-name">{copy.name}</h1>
        {copy.subtitle && <p className="shop-detail-subtitle" data-testid="shop-detail-subtitle">{copy.subtitle}</p>}
        <ShopMeta product={product} t={t}/>
        <p className="shop-level" data-testid="shop-detail-level">{t.level} : {t.levels[product.level]}</p>
        <p className="shop-detail-description" data-testid="shop-detail-description">{copy.description}</p>
        <div className="shop-detail-price" data-testid="shop-detail-price">{product.price_chf ? <>{product.price_chf}<small> CHF</small></> : t.free}<span>{t.pdf} · {lang.toUpperCase()}</span></div>
        {shop.salesEnabled && product.available_languages?.includes(lang) ? <ShopPurchase key={`${product.id}-${lang}`} product={product} lang={lang}/> : <ShopAvailability product={product} t={t}/>}
        {!(shop.salesEnabled && product.available_languages?.includes(lang)) && <p className="shop-detail-pending" data-testid="shop-detail-pending">{t.pending}</p>}
        <section className="shop-contents" aria-labelledby="shop-contents-title">
          <h2 id="shop-contents-title" className="text-base md:text-lg">{t.content}</h2>
          <p data-testid="shop-contents-summary"><Check size={16}/>{included.length ? t.contentsBundle : t.contentsSheet} · {product.pages} {t.pages} A4</p>
          {included.length > 0 && <ul>{included.map(p => <li key={p.id}><Link to={link(p.id)} data-testid={`shop-included-${p.id}`}><span>{p.number} — {p[lang].name}</span><ArrowUpRight size={14}/></Link></li>)}</ul>}
        </section>
        {ideal && <section className="shop-ideal"><h2 className="text-base md:text-lg">{t.ideal}</h2><p data-testid="shop-ideal-for">{ideal}</p></section>}
      </section>
    </div>
  </div>;
}